
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18wu0_1tuc9_93",
  "box": "awsui_box_18wu0_1tuc9_207",
  "p-variant": "awsui_p-variant_18wu0_1tuc9_207",
  "color-default": "awsui_color-default_18wu0_1tuc9_207",
  "b-variant": "awsui_b-variant_18wu0_1tuc9_207",
  "strong-variant": "awsui_strong-variant_18wu0_1tuc9_207",
  "code-variant": "awsui_code-variant_18wu0_1tuc9_207",
  "pre-variant": "awsui_pre-variant_18wu0_1tuc9_207",
  "samp-variant": "awsui_samp-variant_18wu0_1tuc9_207",
  "h1-variant": "awsui_h1-variant_18wu0_1tuc9_211",
  "h2-variant": "awsui_h2-variant_18wu0_1tuc9_211",
  "h3-variant": "awsui_h3-variant_18wu0_1tuc9_211",
  "h4-variant": "awsui_h4-variant_18wu0_1tuc9_211",
  "h5-variant": "awsui_h5-variant_18wu0_1tuc9_211",
  "small-variant": "awsui_small-variant_18wu0_1tuc9_215",
  "a-variant": "awsui_a-variant_18wu0_1tuc9_219",
  "font-size-default": "awsui_font-size-default_18wu0_1tuc9_223",
  "font-weight-default": "awsui_font-weight-default_18wu0_1tuc9_263",
  "key-label-variant": "awsui_key-label-variant_18wu0_1tuc9_303",
  "value-large-variant": "awsui_value-large-variant_18wu0_1tuc9_310",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_1tuc9_317",
  "color-inverted": "awsui_color-inverted_18wu0_1tuc9_322",
  "color-text-label": "awsui_color-text-label_18wu0_1tuc9_325",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_1tuc9_328",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_1tuc9_331",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_1tuc9_334",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_1tuc9_337",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_1tuc9_340",
  "color-text-status-warning": "awsui_color-text-status-warning_18wu0_1tuc9_343",
  "color-inherit": "awsui_color-inherit_18wu0_1tuc9_346",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_1tuc9_349",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_1tuc9_354",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_1tuc9_358",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_1tuc9_362",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_1tuc9_367",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_1tuc9_372",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_1tuc9_377",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_1tuc9_382",
  "font-weight-light": "awsui_font-weight-light_18wu0_1tuc9_387",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_1tuc9_390",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_1tuc9_393",
  "t-left": "awsui_t-left_18wu0_1tuc9_400",
  "t-right": "awsui_t-right_18wu0_1tuc9_404",
  "t-center": "awsui_t-center_18wu0_1tuc9_408",
  "p-n": "awsui_p-n_18wu0_1tuc9_509",
  "p-top-n": "awsui_p-top-n_18wu0_1tuc9_513",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_1tuc9_514",
  "p-right-n": "awsui_p-right-n_18wu0_1tuc9_518",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_1tuc9_519",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_1tuc9_523",
  "p-left-n": "awsui_p-left-n_18wu0_1tuc9_528",
  "p-xxxs": "awsui_p-xxxs_18wu0_1tuc9_533",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_1tuc9_537",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_1tuc9_538",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_1tuc9_542",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_1tuc9_543",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_1tuc9_547",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_1tuc9_552",
  "p-xxs": "awsui_p-xxs_18wu0_1tuc9_557",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_1tuc9_561",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_1tuc9_562",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_1tuc9_566",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_1tuc9_567",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_1tuc9_571",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_1tuc9_576",
  "p-xs": "awsui_p-xs_18wu0_1tuc9_581",
  "p-top-xs": "awsui_p-top-xs_18wu0_1tuc9_585",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_1tuc9_586",
  "p-right-xs": "awsui_p-right-xs_18wu0_1tuc9_590",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_1tuc9_591",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_1tuc9_595",
  "p-left-xs": "awsui_p-left-xs_18wu0_1tuc9_600",
  "p-s": "awsui_p-s_18wu0_1tuc9_605",
  "p-top-s": "awsui_p-top-s_18wu0_1tuc9_609",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_1tuc9_610",
  "p-right-s": "awsui_p-right-s_18wu0_1tuc9_614",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_1tuc9_615",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_1tuc9_619",
  "p-left-s": "awsui_p-left-s_18wu0_1tuc9_624",
  "p-m": "awsui_p-m_18wu0_1tuc9_629",
  "p-top-m": "awsui_p-top-m_18wu0_1tuc9_633",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_1tuc9_634",
  "p-right-m": "awsui_p-right-m_18wu0_1tuc9_638",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_1tuc9_639",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_1tuc9_643",
  "p-left-m": "awsui_p-left-m_18wu0_1tuc9_648",
  "p-l": "awsui_p-l_18wu0_1tuc9_528",
  "p-top-l": "awsui_p-top-l_18wu0_1tuc9_657",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_1tuc9_658",
  "p-right-l": "awsui_p-right-l_18wu0_1tuc9_662",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_1tuc9_663",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_1tuc9_667",
  "p-left-l": "awsui_p-left-l_18wu0_1tuc9_672",
  "p-xl": "awsui_p-xl_18wu0_1tuc9_677",
  "p-top-xl": "awsui_p-top-xl_18wu0_1tuc9_681",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_1tuc9_682",
  "p-right-xl": "awsui_p-right-xl_18wu0_1tuc9_686",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_1tuc9_687",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_1tuc9_691",
  "p-left-xl": "awsui_p-left-xl_18wu0_1tuc9_696",
  "p-xxl": "awsui_p-xxl_18wu0_1tuc9_701",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_1tuc9_705",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_1tuc9_706",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_1tuc9_710",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_1tuc9_711",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_1tuc9_715",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_1tuc9_720",
  "p-xxxl": "awsui_p-xxxl_18wu0_1tuc9_725",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_1tuc9_729",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_1tuc9_730",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_1tuc9_734",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_1tuc9_735",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_1tuc9_739",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_1tuc9_744",
  "m-n": "awsui_m-n_18wu0_1tuc9_749",
  "m-top-n": "awsui_m-top-n_18wu0_1tuc9_753",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_1tuc9_754",
  "m-right-n": "awsui_m-right-n_18wu0_1tuc9_758",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_1tuc9_759",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_1tuc9_763",
  "m-left-n": "awsui_m-left-n_18wu0_1tuc9_768",
  "m-xxxs": "awsui_m-xxxs_18wu0_1tuc9_773",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_1tuc9_777",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_1tuc9_778",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_1tuc9_782",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_1tuc9_783",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_1tuc9_787",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_1tuc9_792",
  "m-xxs": "awsui_m-xxs_18wu0_1tuc9_797",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_1tuc9_801",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_1tuc9_802",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_1tuc9_806",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_1tuc9_807",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_1tuc9_811",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_1tuc9_816",
  "m-xs": "awsui_m-xs_18wu0_1tuc9_821",
  "m-top-xs": "awsui_m-top-xs_18wu0_1tuc9_825",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_1tuc9_826",
  "m-right-xs": "awsui_m-right-xs_18wu0_1tuc9_830",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_1tuc9_831",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_1tuc9_835",
  "m-left-xs": "awsui_m-left-xs_18wu0_1tuc9_840",
  "m-s": "awsui_m-s_18wu0_1tuc9_845",
  "m-top-s": "awsui_m-top-s_18wu0_1tuc9_849",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_1tuc9_850",
  "m-right-s": "awsui_m-right-s_18wu0_1tuc9_854",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_1tuc9_855",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_1tuc9_859",
  "m-left-s": "awsui_m-left-s_18wu0_1tuc9_864",
  "m-m": "awsui_m-m_18wu0_1tuc9_869",
  "m-top-m": "awsui_m-top-m_18wu0_1tuc9_873",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_1tuc9_874",
  "m-right-m": "awsui_m-right-m_18wu0_1tuc9_878",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_1tuc9_879",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_1tuc9_883",
  "m-left-m": "awsui_m-left-m_18wu0_1tuc9_888",
  "m-l": "awsui_m-l_18wu0_1tuc9_768",
  "m-top-l": "awsui_m-top-l_18wu0_1tuc9_897",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_1tuc9_898",
  "m-right-l": "awsui_m-right-l_18wu0_1tuc9_902",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_1tuc9_903",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_1tuc9_907",
  "m-left-l": "awsui_m-left-l_18wu0_1tuc9_912",
  "m-xl": "awsui_m-xl_18wu0_1tuc9_917",
  "m-top-xl": "awsui_m-top-xl_18wu0_1tuc9_921",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_1tuc9_922",
  "m-right-xl": "awsui_m-right-xl_18wu0_1tuc9_926",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_1tuc9_927",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_1tuc9_931",
  "m-left-xl": "awsui_m-left-xl_18wu0_1tuc9_936",
  "m-xxl": "awsui_m-xxl_18wu0_1tuc9_941",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_1tuc9_945",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_1tuc9_946",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_1tuc9_950",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_1tuc9_951",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_1tuc9_955",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_1tuc9_960",
  "m-xxxl": "awsui_m-xxxl_18wu0_1tuc9_965",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_1tuc9_969",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_1tuc9_970",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_1tuc9_974",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_1tuc9_975",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_1tuc9_979",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_1tuc9_984",
  "d-block": "awsui_d-block_18wu0_1tuc9_989",
  "d-inline": "awsui_d-inline_18wu0_1tuc9_992",
  "d-inline-block": "awsui_d-inline-block_18wu0_1tuc9_995",
  "d-none": "awsui_d-none_18wu0_1tuc9_998",
  "f-left": "awsui_f-left_18wu0_1tuc9_1002",
  "f-right": "awsui_f-right_18wu0_1tuc9_1006"
};
  